module.exports = __webpack_public_path__ + "81180a499c2398baec96f09060fe3811.svg";